import "./style.less";

export default function ToggleSwitch() {
    return {
        scope: {
            model: "=",
            labelOn: "@",
            labelOff: "@",
        },
        template: require("./template.html"),
        // COMMENT: on/off states are a little upside down
        controller: function ($scope) {},
    };
}
